import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';

// Fix iOS + Android: prevent topbar from shifting when keyboard closes.
// Only reset scroll when viewport GROWS (keyboard dismissed) — not on keyboard open,
// because firing on shrink causes inner scroll containers to jump to top on input focus.
const resetScroll = () => {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};
document.addEventListener('focusout', () => setTimeout(resetScroll, 100));
if (window.visualViewport) {
  let prevVpHeight = window.visualViewport.height;
  window.visualViewport.addEventListener('resize', () => {
    const h = window.visualViewport.height;
    if (h > prevVpHeight) resetScroll(); // viewport grew = keyboard dismissed
    prevVpHeight = h;
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
